module.exports = __webpack_public_path__ + "img/arrow-down-right-circle-fill.47cf7387.svg";